export interface IStaff {
  idEmployee: string;
  idBranch: string;
  names: string;
  paternalSurname: string;
  maternalSurname: string;
  createdAt: string;
  updatedAt: string;
}

export class Staff {
  idEmployee: string;
  idBranch: string;
  names: string;
  paternalSurname: string;
  maternalSurname: string;
  createdAt: Date;
  updatedAt: Date;

  constructor(data: IStaff) {
    this.idEmployee = data.idEmployee;
    this.idBranch = data.idBranch;
    this.names = data.names;
    this.paternalSurname = data.paternalSurname;
    this.maternalSurname = data.maternalSurname;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
  }

  get getFullName(): string {
    return [this.names, this.paternalSurname, this.maternalSurname]
      .filter(p => !!p)
      .join(' ');
  }

  get getInitials(): string {
    const first = this.names?.charAt(0) ?? '';
    const second = this.paternalSurname?.charAt(0) ?? '';
    return `${first}${second}`.toUpperCase();
  }
}
